import React from 'react';
import { useTranslation } from 'react-i18next';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50vh',
        backgroundColor: '#f7f9fc'
    },
    title: {
        fontSize: '2rem',
        color: '#333',
        marginBottom: '1rem'
    },
    description: {
        fontSize: '1.2rem',
        color: '#666',
        textAlign: 'center' as 'center',
        maxWidth: '400px'
    }
};

const ComingSoon = () => {
    const { t } = useTranslation('portal');
    return (<div style={styles.container}>
        <h1 style={styles.title}>{t('coming-soon')}</h1>
        <p style={styles.description}>{t('coming-soon-subtitle')}</p>
    </div>);
};

export default ComingSoon;
